export default ({vehicle: {vin = ''} = {}} = {}) => vin;
